/* eslint-disable react/prop-types */
import React from "react";

export function TablePlaceHolderItem(props){
    return <tr className='tablePlaceHolder'>
        <td colSpan={props.cols}>
            <div className='row animation' style={{width: props.width}}></div>
        </td>
    </tr>;
}